import * as React from 'react';
import { Typography } from 'antd';
const { Text, Paragraph } = Typography;
import { IWidget } from 'common/schema/widget/Widget';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { WidgetUploadInput } from './WidgetUploadInput';
import { WidgetInputUploadSignedUploadText } from '../../helper/WidgetInputUploadSignedUploadText';

export interface WidgetUploadSignedInputProps {
  widget: IWidget;
  previewOnly?: boolean;
}

export function WidgetUploadSignedInput(props: WidgetUploadSignedInputProps) {
  const { widget, previewOnly } = props;
  if (previewOnly) return null;

  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;
  const options = widget.input?.validation;

  return (
    <>
      <WidgetInputUploadSignedUploadText widget={widget} />
      <WidgetUploadInput
        metadata={metadata}
        name={name}
        options={options}
        description={widget.input?.extra?.uploadDescription}
        procedureId={widget.procedureId}
        widgetType={widget.input?.type}
      />
    </>
  );
}
